<!-- The one-line human moment that rises when a home switches on:
     "The barbecue is lit." Shown for about 1.6 s, then gone. -->
<template>
  <div class="moment-caption" role="status">{{ caption }}</div>
</template>

<script setup>
defineProps({
  caption: { type: String, required: true },
});
</script>
